// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host ion-intem-divider {
  position: relative;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/podcast/podcast.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;AAAE;EACE,kBAAA;EACA,gBAAA;AAEJ","sourcesContent":[":host {\n  display: block;\n  ion-intem-divider {\n    position: relative;\n    overflow: hidden;\n  }\n  .list-view {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
